import colors from '../colors'
import { typography } from '../typography'
export default {
  discountColor: colors.secondary,
  titleLineHeight: typography.body.lineHeight,
  titleWeight: 'normal',
  titleFontFamily: typography.headings.fontFamily,
  priceColor: colors.discount
}
